module.exports = __webpack_public_path__ + "ab9b5d90520e5679c78132d8b472a951.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/pattern-bg/pattern-bg-1.png
// module id = 405
// module chunks = 0